import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-search-bar',
    templateUrl: './search-bar.component.html',
    styleUrls: ['./search-bar.component.css'],
    standalone: false
})
export class SearchBarComponent implements OnInit {
    searchString: string;
    @Output() searchChange = new EventEmitter<string>();

    ngOnInit(): void {
        this.searchString = '';
    }

    onSearchInput(): void {
        this.searchChange.emit(this.searchString);
    }
}
